var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"95vh !important"}})
}
var staticRenderFns = []

export { render, staticRenderFns }